const monitoringAgreementCgsDetailsFields = [
  {
    groupName: "contract_number_contract_signed_date",
    groupLabel: "ბენეფიციარი კომპანიის დასახელება და საიდენტიფიკაციო კოდი, ბენეფიციართან გაფორმებული ხელშეკრულების სესხის ID და გაფორმების/დადასტურების თარიღი",
    fields: [
      {
        name: "company_name",
        label: "სრული სახელი",
        type: "string",
        value: "",
      },
      {
        name: "company_identification_code",
        label: "პ/ნ ან ს/კ",
        type: "text",
        value: "",
      },
      {
        name: "contract_number",
        label: "ხელშეკრულების ნომერი/სესხის/ლიზინგის ID",
        disabled: true,
        type: "text",
        value: "",
      },
      {
        name: "loan_id",
        label: "სესხის ID",
        disabled: true,
        type: "text",
        value: "",
      },
      {
        name: "contract_signed_date",
        label: "სესხის დადასტურების თარიღი",
        disabled: true,
        value: null,
      },
      {
        name: "program_component",
        label: "კომპონენტი",
        type: "select",
        value: "",
      },
      {
        name: "bank",
        label: "ბანკი",
        type: "autocomplete",
        value: "",
      },
      {
        name: "approved_amount",
        label: "დამტკიცებული თანხა",
        type: "number",
        value: 0,
      },
      {
        name: "is_female_entrepreneur",
        label: "ქალი მეწარმე",
        type: "checkbox",
        value: false,
      },
      {
        name: "is_mountain_region",
        label: "მაღალმთიანი რეგიონი",
        type: "checkbox",
        value: false,
      },
      {
        name: "is_income_to_k",
        label: "30 000 ლარამდე შემოსავალის მქონე",
        type: "checkbox",
        value: false,
      },
      {
        name: "is_sun_gate_beneficiary",
        label: "მზის კარის ბენეფიციარი",
        type: "checkbox",
        value: false,
      },
      {
        name: "purpose",
        label: "მიზნობრიობა",
        type: "textarea",
        value: "",
      },
      {
        name: "purpose_detailed",
        label: "მიზნობრიობა დეტალურად",
        type: "textarea",
        value: "",
      },
      {
        name: "project_activities",
        value: "",
        type: "text",
        label: "საქმიანობის სფეროები",
        sub_fields: [],
      },
    ],
  },
];

const monitoringCgsDetailsFields = [
  {
    groupName: "contract_number_contract_signed_date",
    groupLabel: "ბენეფიციარი კომპანიის დასახელება და საიდენტიფიკაციო კოდი, ბენეფიციართან გაფორმებული ხელშეკრულების სესხის ID და გაფორმების/დადასტურების თარიღი",
    fields: [
      {
        name: "company_name",
        label: "სრული სახელი",
        type: "string",
        value: "",
      },
      {
        name: "company_identification_code",
        label: "პ/ნ ან ს/კ",
        type: "text",
        value: "",
      },
      {
        name: "contract_number",
        label: "ხელშეკრულების ნომერი/სესხის/ლიზინგის ID",
        disabled: true,
        type: "text",
        value: "",
      },
      {
        name: "loan_id",
        label: "სესხის ID",
        disabled: true,
        type: "text",
        value: "",
      },
      {
        name: "contract_signed_date",
        label: "სესხის დადასტურების თარიღი",
        disabled: true,
        value: null,
      },
      {
        name: "program_component",
        label: "კომპონენტი",
        type: "select",
        value: "",
      },
      {
        name: "bank",
        label: "ბანკი",
        type: "autocomplete",
        value: "",
      },
      {
        name: "approved_amount",
        label: "დამტკიცებული თანხა",
        type: "number",
        value: 0,
      },
    ],
  },
  {
    groupName: `actual_municipality_address_cadastral_code_is_building_rented`,
    groupLabel: `ბენეფიციარის საქმიანობის განხორციელების ფაქტობრივი მისამართი`,
    fields: [
      {
        name: "actual_municipality",
        label: "",
        type: "autocomplete",
        value: "",
      },
      {
        name: "mountainous_settlement",
        label: "მთიანი დასახლება",
        type: "autocomplete",
        value: "",
      },
      {
        name: "actual_address",
        label: "მისამართი(სოფელი/დაბა/ქუჩა/ნომერი)*",
        type: "text",
        value: "",
      },
      {
        name: "cadastral_code",
        label: "საკადასტრო კოდი",
        type: "text",
        value: "",
      },
    ],
  },
  {
    groupName: `representative_name_phone_position_id_number_email`,
    groupLabel: `ბენეფიციარის წარმომადგენელი პირი`,
    fields: [
      {
        name: "representative_name",
        label: "სახელი, გვარი",
        type: "text",
        value: "",
      },
      {
        name: "representative_phone",
        label: "ტელ. ნომერი",
        type: "text",
        value: "",
      },
      {
        name: "representative_position",
        label: "პოზიცია",
        type: "text",
        value: "",
      },
      {
        name: "representative_id_number",
        label: "პ/ნ",
        type: "text",
        value: "",
      },
      {
        name: "representative_email",
        label: "წარმომადგენლის ელ. ფოსტა",
        type: "text",
        value: "",
      },
    ],
  },
  {
    groupName: "fixed_assets_capital_expenditures_funds_turnover",
    groupLabel: "პროექტის ფარგლებში ბენეფიციარის მხრიდან შესრულებული აქტივობები",
    fields: [
      {
        name: "amount_of_used_amount_table",
        label: "სესხი გახარჯულია მიზნობრივად",
        type: "table",
        tableSchema: [
          {
            fields: [
              {
                name: "machine_equipment_equipment",
                label: "მანქანა - დანადგარები/აღჭურვილობა",
                type: "number",
                value: 0,
              },
              {
                name: "targeted_machine_equipment_equipment",
                label: "მანქანა - დანადგარები/აღჭურვილობა (მიზნობრივი ხარჯები)",
                type: "number",
                value: 0,
              },
              {
                name: "nontargeted_machine_equipment_equipment",
                label: "მანქანა - დანადგარები/აღჭურვილობა (არამიზნობრივი ხარჯები)",
                disabled: true,
                type: "number",
                value: 0,
              },
            ],
          },

          {
            fields: [
              {
                name: "vehicles_special_technic",
                label: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა",
                type: "number",
                value: 0,
              },
              {
                name: "targeted_vehicles_special_technic",
                label: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა (მიზნობრივი ხარჯები)",
                type: "number",
                value: 0,
              },
              {
                name: "nontargeted_vehicles_special_technic",
                label: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა (არამიზნობრივი ხარჯები)",
                disabled: true,
                type: "number",
                value: 0,
              },
            ],
          },

          {
            fields: [
              {
                name: "purchase_building_land",
                label: "შენობა ნაგებობის/მიწის შეძენა",
                type: "number",
                value: 0,
              },
              {
                name: "targeted_purchase_building_land",
                label: "შენობა ნაგებობის/მიწის შეძენა (მიზნობრივი ხარჯები)",
                type: "number",
                value: 0,
              },
              {
                name: "nontargeted_purchase_building_land",
                label: "შენობა ნაგებობის/მიწის შეძენა (არამიზნობრივი ხარჯები)",
                type: "number",
                disabled: true,
                value: 0,
              },
            ],
          },

          {
            fields: [
              {
                name: "building_repairs",
                label: "მშენებლობა/რემონტი",
                type: "number",
                value: 0,
              },
              {
                name: "targeted_building_repairs",
                label: "მშენებლობა/რემონტი (მიზნობრივი ხარჯები)",
                type: "number",
                value: 0,
              },
              {
                name: "nontargeted_building_repairs",
                label: "მშენებლობა/რემონტი (არამიზნობრივი ხარჯები)",
                disabled: true,
                type: "number",
                value: 0,
              },
            ],
          },

          {
            fields: [
              {
                name: "fixed_assets_capital_expenditures",
                label: "ძირითადი საშუალებები/კაპიტალური დანახარჯები",
                type: "number",
                disabled: true,
                value: 0,
              },
              {
                name: "targeted_fixed_assets_capital_expenditures",
                label: "მიზნობრივი ძირითადი საშუალებები/კაპიტალური დანახარჯები",
                type: "number",
                disabled: true,
                value: 0,
              },
              {
                name: "nontargeted_fixed_assets_capital_expenditures",
                label: "არამიზნობრივი ძირითადი საშუალებები/კაპიტალური დანახარჯები",
                type: "number",
                disabled: true,
                value: 0,
              },
            ],
          },

          {
            fields: [
              {
                name: "funds_turnover",
                label: "საბრუნავი საშუალებები",
                type: "number",
                value: 0,
              },
              {
                name: "targeted_funds_turnover",
                label: "საბრუნავი საშუალებები",
                type: "number",
                value: 0,
              },
              {
                name: "nontargeted_funds_turnover",
                label: "საბრუნავი საშუალებები",
                disabled: true,
                type: "number",
                value: 0,
              },
            ],
          },
          {
            fields: [
              {
                name: "is_repayment_amount",
                label: "სესხის ნაწილობრივ/სრულად წინსწრებით დაფარვა",
                type: "checkbox",
                value: false,
              },
              {
                name: "repayment_amount",
                label: "ნაწილობრივ/სრულად დაფარული სესხის თანხა",
                type: "number",
                colSpan: 2,
                value: 0,
              },
            ]
          },
          {
            fields: [
              {
                name: "used_amount",
                label: "ათვისებული თანხის მოცულობა ₾",
                type: "number",
                disabled: true,
                value: 0,
              },
              {
                name: "targeted_used_amount",
                label: "მიზნობრივად ათვისებული თანხის მოცულობა ₾",
                type: "number",
                disabled: true,
                value: 0,
              },
              {
                name: "nontargeted_used_amount",
                label: "არამიზნობრივად ათვისებული თანხის მოცულობა ₾",
                type: "number",
                disabled: true,
                value: 0,
              },
            ],
          },
        ],
      },
      {
        name: "expenseGroups",
        label: "ხარჯვის დამოწმება",
        type: "expense_groups",
        value: [],
      },
      {
        name: "is_sign_inscription_banner",
        type: "select",
        label: `საქმიანობის განხორციელების ადგილას განთავსებულია აბრა წარწერით - პროექტი განხორციელდა პროგრამის "აწარმოე საქართველოში" მხარდაჭერით`,
        value: undefined,
      },
      {
        name: "is_fullfilled_used_amount",
        label: "სესხი გახარჯულია მიზნობრივად",
        type: "checkbox",
        value: false,
      },
      {
        name: "is_loan_documentation_provided",
        label: "სესხის ხარჯვის დოკუმენტაცია სრულად არის წარმოდგენილი",
        type: "checkbox",
        value: false,
      },
      {
        name: "unfulfilled_used_amount_reason",
        label: "არდაკმაყოფილების მიზეზი",
        type: "textarea",
        value: "",
      },
      {
        name: "unfulfilled_used_amount_month_day",
        label: "დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადა (თვე/დღე)",
        type: "day",
        value: 0,
      },
      {
        name: "monitoring_new_deadline",
        label: "გამეორებითი მონიტორინგის ჩატარების თარიღი",
        type: "date",
        value: "",
      },
      {
        name: "unfulfilled_used_amount_recommendation_reason",
        label: "დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადისთვის გაცემული რეკომენდაცია",
        type: "textarea",
        value: "",
      },
      {
        name: "is_new_deadline_approved",
        label: "დადასტურება ვადის ცვლილების შესახებ დეპ. უფროსის მიერ",
        type: "checkbox",
        value: false,
      },
      {
        name: "monitoring_deadline_comment",
        label: "დეპ. უფროსის მიერ დარღვევის აღმოსაფხვრელად მიცემული ერთ წელზე მეტი ვადის შესახებ კომენტარი",
        type: "textarea",
        value: "",
      },

      {
        name: "project_activities",
        value: "",
        type: "autocomplete",
        optionName: "cgs_nace_activities",
        label: "საქმიანობის სფეროები",
      },
      {
        name: "is_taken_business_loan_leasing",
        type: "checkbox",
        label: "სარგებლობდა საფინანსო ინსტიტუტების ბიზნესის მხარდამჭერი საკრედიტო პროდუქტებით (სესხი/ლიზინგი)",
        value: undefined,
      },
      {
        name: "monitoring_approval_deadline_comment",
        label: "მონიტორინგის ვადაგადაცილების კომენტარი",
        type: "textarea",
        value: "",
      },
      {
        name: "agency_approve_comment",
        label: "სააგენტოს დადასტურების კომენტარი",
        type: "textarea",
        value: "",
      },

      {
        name: "additional_comments",
        label: "დამატებითი კომენტარი",
        type: "textarea",
        value: "",
      },
    ],
  },
];

export { monitoringCgsDetailsFields, monitoringAgreementCgsDetailsFields };
